import axiosInstance from "../core/index-core";

class PracticeService {
  baseUrl = "/api/admin/practices";

  static getInstance() {
    if (!PracticeService._instance) {
      PracticeService._instance = new PracticeService();
    }
    return PracticeService._instance;
  }

  async listPractices() {
    const { data } = await axiosInstance.get(this.baseUrl);
    return data;
  }

  async getPractice(practiceId) {
    const { data } = await axiosInstance.get(`${this.baseUrl}/${practiceId}`);
    return data;
  }

  async createPractice(payload) {
    const { data } = await axiosInstance.post(this.baseUrl, payload);
    return data;
  }

  async updateDefaults(practiceId, payload) {
    const { data } = await axiosInstance.patch(
      `${this.baseUrl}/${practiceId}/defaults`,
      payload
    );
    return data;
  }

  async updatePractice(practiceId, payload) {
    const { data } = await axiosInstance.patch(
      `${this.baseUrl}/${practiceId}`,
      payload
    );
    return data;
  }

  async deactivatePractice(practiceId) {
    const { data } = await axiosInstance.delete(`${this.baseUrl}/${practiceId}`);
    return data;
  }
}

const practiceService = PracticeService.getInstance();

export default practiceService;
